export default "__VITE_ASSET__c97bc369__"